import { render } from "./WhitelabelRegister.vue?vue&type=template&id=771670ca&scoped=true"
import script from "./WhitelabelRegister.vue?vue&type=script&lang=js"
export * from "./WhitelabelRegister.vue?vue&type=script&lang=js"

import "./WhitelabelRegister.vue?vue&type=style&index=0&id=771670ca&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771670ca"]])

export default __exports__